import axios from "axios";

// export const getCategories = async (companyId) => {
//     const response = await axios.get(`api/taskincidentcategories/${companyId}`);
//     const result = response.data;
//     return result;
// }

export const postCategoryValues = async (data) => {
    const response = await axios.post("api/taskincidentcategoryvalues", data);
    const result = response.data;
    return result;
}

// export const patchCategory = async (data) => {
//     const response = await axios.patch("api/taskincidentcategories", data);
//     const result = response.data;
//     return result;
// }


